module.exports = __webpack_public_path__ + "static/media/gaxon.32cebc42.eot";